export const CAN_OPTIONS = [
  { label: 'can0', value: 'can0' },
  { label: 'can1', value: 'can1' },
  { label: 'can2', value: 'can2' },
  { label: 'can3', value: 'can3' },
];

export const FIELD_TYPE_OPTIONS = [
  { label: 'unused', value: '' },
  { label: 'uint32 (or smaller uint)', value: 'uint32' },
  { label: 'uint64', value: 'uint64' },
  { label: 'int16', value: 'int16' },
  { label: 'int32', value: 'int32' },
  { label: 'int64', value: 'int64' },
  { label: 'float32', value: 'float32' },
  { label: 'float64', value: 'float64' },
  { label: 'uint32 (or smaller uint, big endian)', value: 'uint32-be' },
  { label: 'uint64 (big endian)', value: 'uint64-be' },
  { label: 'int16 (big endian)', value: 'int16-be' },
  { label: 'int32 (big endian)', value: 'int32-be' },
  { label: 'int64 (big endian)', value: 'int64-be' },
  { label: 'float32 (big endian)', value: 'float32-be' },
  { label: 'float64 (big endian)', value: 'float64-be' },
  { label: 'ASCII', value: 'ascii' },
];

export const ENGINE_HOURS = 'engine_hours';
export const FUEL_USED = 'fuel_used';
export const IDLE_ENGINE_HOURS = 'idle_engine_hours';
export const IDLE_FUEL_USED = 'idle_fuel_used';

export const REPORTING_TYPE_OPTIONS = [
  { label: ENGINE_HOURS, value: ENGINE_HOURS },
  { label: IDLE_ENGINE_HOURS, value: IDLE_ENGINE_HOURS },
  { label: FUEL_USED, value: FUEL_USED },
  { label: IDLE_FUEL_USED, value: IDLE_FUEL_USED },
];

export const DAILY = 'daily';
export const LIFETIME = 'lifetime';
export const MONTHLY = 'monthly';
export const WEEKLY = 'weekly';

export const SA_TOOLTIP_MESSAGE =
  '"Source" field must include can<N>.j1939 value';
